export default function filterRecords(
	records: any[],
	searchString: string,
	sortableColumns?: string[]
): any[] {
	searchString = searchString.toLowerCase()
	return records.filter((record) => {
		const filterableRecords: any = {}
		// Add record column as filterable
		sortableColumns?.forEach((recordKey: any) =>
			Object.assign(filterableRecords, { [recordKey]: record[recordKey] })
		)

		const areSomeColumnsFilterable = sortableColumns && sortableColumns.length > 0
		if (
			JSON.stringify(areSomeColumnsFilterable ? filterableRecords : record)
				.toLowerCase()
				.includes(searchString)
		) {
			return record
		}
	})
}
